const AllRoles = {
    "Real Estate": {
        "Properties": [
            { name: "View Properties", value: "view_property", check: false, isDisabled: false },
            { name: "Add Properties", value: "add_property", check: false, isDisabled: false },
            { name: "Edit Properties", value: "change_property", check: false, isDisabled: false },
            { name: "Delete Properties", value: "delete_property", check: false, isDisabled: false },
            { name: "View Contract", value: "view_contract", check: false, isDisabled: false },
            { name: "Add Contract", value: "add_contract", check: false, isDisabled: false },
            { name: "Edit Contract", value: "change_contract", check: false, isDisabled: false },
            { name: "Delete Contract", value: "delete_contract", check: false, isDisabled: false },
        ],
        "Landlord": [
            { name: "View Landlord", value: "view_landlord", check: false, isDisabled: false },
            { name: "Add Landlord", value: "add_landlord", check: false, isDisabled: false },
            { name: "Edit Landlord", value: "change_landlord", check: false, isDisabled: false },
            { name: "Delete Landlord", value: "delete_landlord", check: false, isDisabled: false },
        ],
        "Building": [
            { name: "View Building", value: "view_building", check: false, isDisabled: false },
            { name: "Add Building", value: "add_building", check: false, isDisabled: false },
            { name: "Edit Building", value: "change_building", check: false, isDisabled: false },
            { name: "Delete Building", value: "delete_building", check: false, isDisabled: false },
        ],
        "Annual Statements": [
            { name: "View Annual Statements", value: "view_annualstatement", check: false, isDisabled: false },
            { name: "Add Annual Statements", value: "add_annualstatement", check: false, isDisabled: false },
            { name: "Edit Annual Statements", value: "change_annualstatement", check: false, isDisabled: false },
            // { name: "Delete Annual Statements", value: "delete_annualstatement", check: false, isDisabled: false },
        ],
        "Maintenance": [
            { name: "View Handyman", value: "view_handyman", check: false, isDisabled: false },
            { name: "Add Handyman", value: "add_handyman", check: false, isDisabled: false },
            { name: "Edit Handyman", value: "change_handyman", check: false, isDisabled: false },
            { name: "Delete Handyman", value: "delete_handyman", check: false, isDisabled: false },
            { name: "View Damage", value: "view_damagereport", check: false, isDisabled: false },
            { name: "Add Damage", value: "add_damagereport", check: false, isDisabled: false },
            { name: "Edit Damage", value: "change_damagereport", check: false, isDisabled: false },
            { name: "Delete Damage", value: "delete_damagereport", check: false, isDisabled: false },
            // { name: "Process Damage", value: "delete_process", check: false, isDisabled: false },
            { name: "View Maintenance Request", value: "view_damage", check: false, isDisabled: false },
            { name: "Delete Maintenance Request", value: "delete_damage", check: false, isDisabled: false },
            { name: "Process Maintenance Request", value: "change_damage", check: false, isDisabled: false },
        ],
    },
    "Tenant": {
        "Tenant": [
            { name: "View Tenant", value: "view_tenant", check: false, isDisabled: false },
            { name: "Add Tenant", value: "add_tenant", check: false, isDisabled: false },
            { name: "Edit Tenant", value: "change_tenant", check: false, isDisabled: false },
            { name: "Delete Tenant", value: "delete_tenant", check: false, isDisabled: false },
            { name: "Assign other office", value: "assign_other_office", check: false, isDisabled: false },
        ],
    },
    "Administrator": {
        "Office Unit": [
            { name: "View Unit", value: "view_officeunit", check: false, isDisabled: false },
            { name: "Add Unit", value: "add_officeunit", check: false, isDisabled: false },
            { name: "Edit Unit", value: "change_officeunit", check: false, isDisabled: false },
            { name: "Delete Unit", value: "delete_officeunit", check: false, isDisabled: false },
        ],
        "Office": [
            { name: "View Office", value: "view_office", check: false, isDisabled: false },
            { name: "Add Office", value: "add_office", check: false, isDisabled: false },
            { name: "Edit Office", value: "change_office", check: false, isDisabled: false },
            { name: "Delete Office", value: "delete_office", check: false, isDisabled: false },
        ],
        "Employee": [
            { name: "View Employee", value: "view_employee", check: false, isDisabled: false },
            { name: "Add Employee", value: "add_employee", check: false, isDisabled: false },
            { name: "Edit Employee", value: "change_employee", check: false, isDisabled: false },
            { name: "Delete Employee", value: "delete_employee", check: false, isDisabled: false },
        ],
        "Role": [
            { name: "View Role", value: "view_companyrole", check: false, isDisabled: false },
            { name: "Add Role", value: "add_companyrole", check: false, isDisabled: false },
            { name: "Edit Role", value: "change_companyrole", check: false, isDisabled: false },
            { name: "Delete Role", value: "delete_companyrole", check: false, isDisabled: false },
        ],
    },

    "Settings": {
        "Settings": [
            { name: "Access Internal Rent Settings", value: "internalrentsetting", check: false },
            { name: "Access External Rent settings", value: "externalrentmaintenacesetting", check: false },
            { name: "Access Plans", value: "access_plans", check: false },
            { name: "Services", value: "services", check: false },
        ],
    }
}

export default AllRoles;